<template>
  <span
    v-if="conversion.eur_rate != null"
    class="badge bg-light text-dark border fw-normal"
    :title
  >
    {{ text }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { DealEurConversion } from "@/types";

/**
 * Marks an admin report row whose EUR figures were converted from a deal in another currency.
 * Renders nothing for an EUR deal, which the backend reports with no rate. The rate is printed as
 * the backend sends it, so "0.8" stays "0.8".
 */
const props = defineProps<{
  conversion: DealEurConversion;
}>();

const text = computed(
  () =>
    `converted from ${props.conversion.currency} at ${props.conversion.eur_rate}` +
    (props.conversion.eur_rate_indicative ? " (indicative)" : "")
);

const title = computed(
  () =>
    `EUR figures of a ${props.conversion.currency} deal, at ${props.conversion.eur_rate} ` +
    `${props.conversion.currency} per EUR (ECB)` +
    (props.conversion.eur_rate_indicative
      ? ", today's rate until the buyer invoice fixes it"
      : "")
);
</script>
